module.exports = __webpack_public_path__ + "static/media/bruno-abatti.80954654.jpg";